import React from 'react';
import './cardHeader.css';

const CardHeader = ({children}) => (
  <div className="cardHeader">
      {children}
  </div>
);

export default CardHeader;
